import { apiGet, apiPost } from './client';
import type { LoginDto, LoginResponse, JwtUser } from '../types';

export async function login(dto: LoginDto): Promise<LoginResponse> {
  return apiPost<LoginResponse>('/auth/login', dto);
}

export async function getMe(): Promise<JwtUser> {
  return apiGet<JwtUser>('/auth/me');
}
